import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 6A41607E-FD2D-49EB-B6A5-67472ECF381E
 * name alpha-t-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-t-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaTCircleIcon = createSvgIcon(<><path d="M9,7V9H11V17H13V9H15V7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z" /></>, 'AlphaTCircleIcon');
export default AlphaTCircleIcon